/// <amd-module name="Search/Wiki/Components/Results" />

import * as React from "react";
import * as Container from "Search/Shared/Base/Container";
import { FilterPaneContainer } from "Search/Wiki/Components/FilterPaneContainer";
import { SearchResultsList } from "Search/Wiki/Components/SearchResultsList";
import { ZeroDataContainer } from "Search/Wiki/Components/ZeroData";
import { OverlayContainer } from "Search/Wiki/Components/Overlay";
import { ActionCreator } from "Search/Wiki/Flux/ActionCreator";
import { StoreName, StoresHub, IAggregatedState } from "Search/Wiki/Flux/StoresHub";

export const ResultsContainer = Container.create<StoreName, ActionCreator, IAggregatedState, StoresHub>(
    ["searchStore"],
    ({ searchStoreState }, props) => {
        return (
            <div className="search-view-container flex-column flex-grow">
                <FilterPaneContainer {...props} />
                <div className="wiki-search-results flex-column flex-grow relative">
                    <OverlayContainer {...props} />
                    <ZeroDataContainer {...props} />
                    <SearchResultsList
                        pageContext={props.pageContext}
                        actionCreator={props.actionCreator}
                        searchStoreState={searchStoreState}
                    />
                </div>
            </div>
        );
    });
